import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { Apps } from './useInfoStatus';

interface IExtension {
  extension?: string;
  name: string;
}

export const useGetCalleeFromDestination = (destination?: string): string => {
  const ivrMenus = useSelector((state: RootState) => state.apps.data.ivr_menu ?? []);
  const ringGroups = useSelector((state: RootState) => state.apps.data.ring_group ?? []);
  const extensions = useSelector((state: RootState) => state.apps.data.extension ?? []);
  const callCenterData = useSelector((state: RootState) => state.apps.data.queue ?? []);

  const directoryMaps = useMemo(() => {
    const ivrMap = new Map<string, IExtension>();
    const ringGroupMap = new Map<string, IExtension>();
    const extMap = new Map<string, IExtension>();
    const queueMap = new Map<string, IExtension>();

    ivrMenus.forEach(item => {
      if (item.extension) {
        ivrMap.set(item.extension, item);
      }
    });

    ringGroups.forEach(item => {
      if (item.extension) {
        ringGroupMap.set(item.extension, item);
      }
    });

    extensions.forEach(item => {
      if (item.extension) {
        extMap.set(item.extension, item);
      }
    });

    callCenterData.forEach(item => {
      if (item.extension) {
        queueMap.set(item.extension, item);
      }
    });

    return { ivrMap, ringGroupMap, extMap, queueMap };
  }, [ivrMenus, ringGroups, extensions, callCenterData]);

  const calleeLabel = useMemo(() => {
    if (!destination) return 'Unknown';

    const { ivrMap, ringGroupMap, extMap, queueMap } = directoryMaps;

    const matchedIVR = ivrMap.get(destination);
    const matchedRing = ringGroupMap.get(destination);
    const matchedExt = extMap.get(destination);
    const matchedQueue = queueMap.get(destination);

    if (matchedQueue) {
      return `${matchedQueue.name} - (${Apps.QUEUE})`;
    }

    if (matchedExt) {
      return `${matchedExt.name} - (${Apps.EXTENSION})`;
    }

    if (matchedRing) {
      return `${matchedRing.name} - (${Apps.RING_GROUP})`;
    }

    if (matchedIVR) {
      return `${matchedIVR.name} - (${Apps.IVR})`;
    }

    return 'Unknown';
  }, [destination, directoryMaps]);

  return calleeLabel;
};

